import { connect } from "react-redux";
import { PageSummary } from "senac-components";
import { commonSlice, contentSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import { Wrapper, WrapperDispatchProps, WrapperStateProps } from "./Wrapper";
import { Content, ContentHeaderOptionItem, MenuOptions } from "senac-components/dist/pages/Mobile/PageInterfaces";
import { PageSummaryPropsDispach, PageSummaryStateProps } from "senac-components/dist/pages/Mobile/PageSummary";
import { ContentType, contentSummary, openContent } from "../store/reducers/contentSlice";


const mapState = (state: RootState, props: any) => 
{
  const activeContent = state.contentState.allContents.find(p=> p.uid == state.contentState.activeContentUid);
  const content = { ...activeContent ?? {uid:"-"} }
  const contentSummary = state.contentState.contentSummary;

  let result: PageSummaryStateProps & WrapperStateProps = {
    contentsFavorited:  [],
    contentsDownloaded: [],
    authenticatedUser : state.userState.user != undefined,
    summaries: contentSummary,
    content:content,
    element: PageSummary, //todo: tratar caso onde é nulo
    availableEpubFormat: true,
    availablePdfFormat: true,
    loadingSummary: state.contentState.loadingSummary,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch, props:any) => 
{
  const result: PageSummaryPropsDispach & WrapperDispatchProps = 
  {
    onClickItemSummary(summaryItem) {
      dispatch(contentSlice.actions.setSummaryItem(summaryItem))
    },
    onChangeParams: (content) => {
      // dispatch(contentSlice.actions.setLoadingSummary(true));
      // dispatch(contentSummary(content));
    },
    onSelectedHeaderBack: ()=> dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option:ContentHeaderOptionItem)=> dispatch(contentSlice.actions.goToContentInfo(option)),
    onSelectedNavigationPageOption: (option:MenuOptions) => dispatch(commonSlice.actions.goToPage(option)),
    onClickHelp: () => dispatch(commonSlice.actions.helpPage()),
  };
  return result;
};

const WPageBookSummary = connect(mapState, mapDispatch)(Wrapper);

export { WPageBookSummary };
